<template>
  <div class="py-5 text-center abbv-wrapper">
    <div class="container">
      <div class="mb-4"><img src="https://snippcheck.blob.core.windows.net/files/WKKC_2008807_CAWalmart_GWP/logo.png"
          alt="WK Kellogg Logo" class="img-fluid" width="300"></div>
      <div v-html="$t('Footer.legalrules')" class="small" @click="handleLinkClick"></div>
    </div>
  </div>
  <footer class="py-4 text-center">

    <div class="navbar px-4 py-0">
      <div class="col">
        <ul class="list-inline mb-0" id="footer-nav">
          <li class="list-inline-item ps-0" v-html="$t('Footer.TandCLink')"></li>
          <li class="list-inline-item" v-html="$t('Footer.PrivacyNoticeLink')"></li>
          <li class="list-inline-item" v-html="$t('Footer.TermsOfUseLink')"></li>
          <li class="list-inline-item"><a nohref='nohref' class='track ot-sdk-show-settings' style='cursor: pointer'
              :aria-label='$t("Footer.CookiePreferencesLink")' v-html="$t('Footer.CookiePreferencesLink')"></a></li>
          <li class="list-inline-item" v-html="$t('Footer.AccessibilityLink')"></li>
          <li class="list-inline-item" v-html="$t('Footer.WKKelloggLink')"></li>
          <li class="list-inline-item" v-html="$t('Footer.ContactUsLink')"></li>
        </ul>
        <p class="mt-3 mb-0 small">
          <small v-html="$t('Footer.copyrighttext')"></small> <small>{{ new Date().getFullYear() }}</small> <small
            v-html="$t('Footer.AllrightReserved')"></small>
        </p>

      </div>
    </div>
  </footer>
</template>

<script>
//Younet chatbot code apprended in the body
export default {
  mounted() {
    // // Dynamically fetch the translated modelHash
    /* const modelHash = this.$t('YounetmodelHash');
     const modelImgurl = this.$t('YounetmodelIMg');
     const scriptUrl = `https://widget.younet.ai/index.js?modelHash=${modelHash}&type=bubble&imgUrl=${modelImgurl}&bottom=90`;
 
     // // Dynamically create the script element
     const script = document.createElement('script');
     script.type = 'module';
     script.src = scriptUrl;
 
     // // Append the script to the body
     document.body.appendChild(script);*/
  },
  methods: {
    // New method: make <a> behave like router-links
    handleLinkClick(event) {
      const target = event.target.closest('a');
      if (target) {
        const href = target.getAttribute('href');

        if (href && href.startsWith('/')) {
          event.preventDefault();
          this.$router.push(href);
        }
      }
    }
  }
};
</script>